var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfiguracionDePerfiles(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:#FFFFFF;stroke:#95D4E9;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Configuraci\\xF3n_de_perfiles",
    transform: "translate(-191.5 -695.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18998",
    className: "st0",
    d: "M195.6,769.1v-37.8h66.2v37.8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4299",
    x: 195.5,
    y: 731.1,
    className: "st0",
    width: 15,
    height: 38
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4300",
    x: 210.5,
    y: 696.1,
    className: "st1",
    width: 38,
    height: 26
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4301",
    x: 227.5,
    y: 722.1,
    className: "st0",
    width: 5,
    height: 9
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_27",
    className: "st0",
    x1: 192.5,
    y1: 731.1,
    x2: 265.5,
    y2: 731.1
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_28",
    className: "st0",
    x1: 261.5,
    y1: 740.1,
    x2: 210.5,
    y2: 740.1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfiguracionDePerfiles);
export default __webpack_public_path__ + "static/media/Configuracion-de-perfiles.7cbb057cff285b042cbcf9d3c78b4cb0.svg";
export { ForwardRef as ReactComponent };